<template>
  <div class="msg-form-wrapper">
  <div class="formDiv">
    <van-form @failed="onFailed" @submit="onSubmit">
      <van-cell-group>
        <!-- 循环显示 -->
        <div v-for="item in formItems" :key="item.key">
          <van-field
            v-if="
              item.key !== 'Gender' &&
              item.key !== 'Country' &&
              item.key !== 'Province' &&
              item.key !== 'City' &&
              item.key !== 'Trade' &&
              item.key !== 'photo' &&
              item.key !== 'IDCardType' &&
              item.key !== 'ExtField1'&&
              item.key !== 'ComName'
            "
            v-model="formMg[item.key]"
            :name="item.key"
            :rules="rulesAll[item.key]"
            :class="item.IsMust ? 'requiredItem' : ''"
            :readonly="
              (item.key === 'Mobile' && tabac === 'dl') ||
              (item.key === 'Email' && tabac === 'gat')
            "
          >
            <template #label>
              <span>{{ item.Name }}</span>
              <span class="label-en">{{ item.EName }}</span>
            </template>
          </van-field>
          <div v-else-if="item.key === 'ComName'" style="position: relative;">
          <van-field
            v-model="formMg[item.key]"
            :name="item.key"
            :rules="rulesAll[item.key]"
            :class="item.IsMust ? 'requiredItem' : ''"
          >
            <template #label>
              <span>{{ item.Name }}</span>
              <span class="label-en">{{ item.EName }}</span>
            </template>
          </van-field>

          <div v-if="companySuggestions && companySuggestions.length > 0&&item.key=='ComName'" class="suggestion-list" ref="suggestionListRef">
        <div
          v-for="(suggestion, index) in companySuggestions"
          :key="index"
          class="suggestion-item"
          @click="selectSuggestion(suggestion)"
        >
          {{ suggestion }}
        </div>
      </div>
          </div>
          <!-- 头像 -->
          <van-field
            v-if="item.key === 'photo'"
            :name="formMg[item.key]"
            label="头像"
            :rules="rulesAll.photo"
            :class="item.IsMust ? 'photoForm requiredItem' : 'photoForm'"
            v-model="formMg[item.key]"
          >
            <template #input>
              <cropper @send-photo="sendphoto" />
            </template>
          </van-field>
          <!-- gender -->
          <van-field
            v-if="item.key === 'Gender'"
            :class="item.IsMust ? 'requiredItem' : ''"
            :name="item.key"
            :label="item.Name + '/' + item.EName"
            :rules="rulesAll.Gender"
          >
            <template #input>
              <van-radio-group v-model="formMg.Gender" direction="horizontal">
                <van-radio name="男">男</van-radio>
                <van-radio name="女">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <!-- 国家选择pc -->
          <template v-if="item.key === 'Country'">
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem' : ''"
                :readonly="true"
                v-model="formMg.Country"
                :name="item.key"
                :label="item.Name + '/' + item.EName"
                :rules="rulesAll.Country"
              >
              </van-field>
              <select v-model="formMg.Country" @change="changeCountry">
                <option
                  v-for="(item, index) in columns"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 国家 移动 -->
            <van-field
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-if="!isPC"
              v-model="formMg.Country"
              is-link
              readonly
              name="Country"
              :label="item.Name + '/' + item.EName"
              @click="showPicker = true"
              :rules="rulesAll.Country"
            >
            </van-field>
            <van-popup v-model:show="showPicker" position="bottom">
              <van-picker
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
              />
            </van-popup>
          </template>
          <!-- 省份 -->
          <template v-if="item.key === 'Province'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                :readonly="true"
                v-model="formMg.Province"
                :name="item.key"
                :rules="rulesAll.Province"
                :disabled="formMg.Country !== '中国'"
              >
                <template #label>
                  <span>{{ item.Name }}</span>
                  <span class="label-en">{{ item.EName }}</span>
                </template>
              </van-field>
              <select
                v-model="formMg.Province"
                @change="changeProvince"
                :disabled="formMg.Country !== '中国'"
              >
                <option
                  v-for="(item, index) in columnsProvince"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-if="!isPC"
              v-model="formMg.Province"
              is-link
              readonly
              :name="item.key"
              @click="columnsProvince.length > 0 ? (showPickerPro = true) : ''"
              :rules="rulesAll.Province"
              :disabled="formMg.Country !== '中国'"
            >
              <template #label>
                <span>{{ item.Name }}</span>
                <span class="label-en">{{ item.EName }}</span>
              </template>
            </van-field>
            <van-popup v-model:show="showPickerPro" position="bottom">
              <van-picker
                :columns="columnsProvince"
                @confirm="onConfirmProvince"
                @cancel="showPickerPro = false"
              />
            </van-popup>
          </template>
          <!-- 城市 -->
          <template v-if="item.key === 'City'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                :readonly="true"
                v-model="formMg.City"
                :name="item.key"
                :rules="rulesAll.City"
                :disabled="formMg.Country !== '中国'"
              >
                <template #label>
                  <span>{{ item.Name }}</span>
                  <span class="label-en">{{ item.EName }}</span>
                </template>
              </van-field>
              <select
                v-model="formMg.City"
                :disabled="formMg.Country !== '中国'"
              >
                <option
                  v-for="(item, index) in columnsCity"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              v-else
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.City"
              is-link
              readonly
              :name="item.key"
              @click="columnsCity.length > 0 ? (showShopPicker = true) : ''"
              :rules="rulesAll.City"
              :disabled="formMg.Country !== '中国'"
            >
              <template #label>
                <span>{{ item.Name }}</span>
                <span class="label-en">{{ item.EName }}</span>
              </template>
            </van-field>
            <van-popup v-model:show="showShopPicker" position="bottom">
              <van-picker
                :columns="columnsCity"
                @confirm="shopConfirm"
                @cancel="showShopPicker = false"
              />
            </van-popup>
          </template>
          <!-- 行业 -->
          <template v-if="item.key === 'Trade'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.Trade"
                :name="item.key"
                :label="item.Name"
                :rules="rulesAll.Trade"
              >
              </van-field>
              <select v-model="formMg.Trade">
                <option
                  v-for="(item, index) in item.Options"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              v-else
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.Trade"
              :name="item.key"
              :label="item.Name + '/' + item.EName"
              @click="showTradePicker = true"
              :rules="rulesAll.Trade"
              readonly
            />
            <van-popup v-model:show="showTradePicker" position="bottom">
              <van-picker
                :columns="tradeOptions"
                @confirm="tradeConfirm"
                @cancel="showTradePicker = false"
              />
            </van-popup>
          </template>
          <!-- ExtField1 -->
          <template
            v-if="
              item.key === 'ExtField1' &&
              (regType === 'st' ||
                pageType === 'help' ||
                (regType === 'gz' && isClickCh))
            "
          >
            <!-- 移动 -->
            <van-field
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.ExtField1"
              :name="item.key"
              @click="showMeetList"
              :rules="rulesAll.ExtField1"
              readonly
            >
              <template #label>
                <span>{{ item.Name }}</span>
                <span class="label-en">{{ item.EName }}</span>
              </template>
            </van-field>
          </template>
          <!-- ExtField2 -->
          <!-- <template v-if="item.key === 'ExtField2'">
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.ExtField2"
                :name="item.key"
                :label="item.Name"
                :rules="rulesAll.ExtField2"
              >
              </van-field>
              <select v-model="formMg.ExtField2">
                <option
                  v-for="(item, index) in ExtField2Ops"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <van-field
              v-else
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.ExtField2"
              :name="item.key"
              :label="item.Name"
              @click="showF2Picker = true"
              :rules="rulesAll.ExtField2"
              readonly
            />
            <van-popup v-model:show="showF2Picker" position="bottom">
              <van-picker
                :columns="ExtField2Ops"
                @confirm="f2Confirm"
                @cancel="showF2Picker = false"
              />
            </van-popup>
          </template> -->
          <!-- 身份证件类型 -->
          <template v-if="item.key === 'IDCardType'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.IDCardType"
                :name="item.key"
                :rules="rulesAll.IDCardType"
                :placeholder="item.holder"
              >
                <template #label>
                  <span>{{ item.Name }}</span>
                  <span class="label-en">{{ item.EName }}</span>
                </template>
              </van-field>
              <select v-model="formMg.IDCardType">
                <option
                  v-for="(item, index) in IDTypes"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              v-else
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.IDCardType"
              is-link
              readonly
              :name="item.key"
              @click="showIDTypePicker = true"
              :rules="rulesAll.IDCardType"
              :placeholder="item.holder"
            >
              <template #label>
                <span>{{ item.Name }}</span>
                <span class="label-en">{{ item.EName }}</span>
              </template>
            </van-field>
            <van-popup v-model:show="showIDTypePicker" position="bottom" :teleport="null">
              <van-picker
                :columns="IDTypes"
                :item-height="60"
                @confirm="IDTypeConfirm"
                @cancel="showIDTypePicker = false"
                class="id-type-picker"
              >
                <template v-slot:option="slotProps">
                  <div class="id-type-option">
                    <div class="id-type-cn">{{ slotProps.option?.text?.split(' / ')[0] || slotProps.text?.split(' / ')[0] }}</div>
                    <div class="id-type-en">{{ slotProps.option?.text?.split(' / ')[1] || slotProps.text?.split(' / ')[1] }}</div>
                  </div>
                </template>
              </van-picker>
            </van-popup>
          </template>
        </div>
      </van-cell-group>
      <!-- 多选问题 -->
      <div class="que-box">
        <quetions
          v-model="formMg.QueAndAnswers"
          ref="chooseQues"
          :quesConfig="useQues"
        ></quetions>
      </div>
<div v-if="regType === 'hz'" class="cooperation-contact">
  <p class="contact-title">合作联系人 Contact</p>
  <p class="contact-name" style="margin-bottom: 12px;"><img src="@/assets/personicon.png" class="contact-icon" />朱勤超</p>
  
  <p class="contact-phone"><img src="@/assets/mobileicon.png" class="contact-icon" />17625644396</p>
  <p class="contact-email"><img src="@/assets/emailicon.png" class="contact-icon" />zhuqinchao@helloh2.com</p>
</div>

      <div class="msg-divider"></div>

      <div class="btn-group-wrap">
        
        <van-button color="#003df2" type="primary" native-type="submit" class="submit-btn">
          提    交
          <br />
                  <span class="btn-en">Submit</span>
        </van-button>
        <van-button
          color="#003df2"
          type="primary"
          v-if="regType === 'st' || pageType === 'help'"
          @click="showSchedulePopup = true"
        >
          日程查看
          <br />
                  <span class="btn-en">View Agenda</span>
        </van-button>
        <van-button
          color="#003df2"
          type="primary"
          @click="isClickCh = true"
          v-if="regType === 'gz'"
        >
          我要参会<br />
                  <span class="btn-en">Conference Registration</span>
        </van-button>
        <van-button
          color="#003df2"
          type="primary"
          @click="showPlacePopup = true"
          v-if="regType === 'hz'"
        >
          场地查询
          <br />
          <span class="btn-en">Venue Inquiry</span>
        </van-button>
        <van-button color="#003df2" plain type="primary" @click="goBack"> 返回 
          <br />
                  <span class="btn-en">Back</span>
        </van-button>
      </div>
    </van-form>
    <!-- <-- ExtField1 meetList -->
    <van-popup v-model:show="showF1Picker" position="bottom" :style="{ height: '100%' }" :teleport="false" :lock-scroll="false">
      <chooseMeet
        @confirm="confirmChooseMeet"
        @cancel="showF1Picker = false"
        idType="id"
        :hasChecked="hasChecked"
      />
    </van-popup>

    <!-- 日程查看弹层 -->
    <van-popup v-model:show="showSchedulePopup" position="bottom" :style="{ height: isPC ? '70%' : '90%', overflowY: 'scroll' }" round :lock-scroll="false" ref="schedulePopupRef" @opened="onScheduleOpened">
      <div class="schedule-page">
    <h2 class="page-title-cn">活动日程安排</h2>
    <h1 class="page-title">Event Schedule</h1>
    
    <!-- 2026年3月25日 -->
    <div class="day-section">
      <div class="date-header">
        <div class="date-cn">2026年3月25日</div>
        <div class="date-en">March 25, 2026</div>
      </div>
      <div class="timeline">
        <div class="event-card">
          <div class="event-header">
            <div class="time">09:00-10:00</div>
            <div class="event-tag">· 闭门会议 <span>Closed-door Meeting</span></div>
          </div>
          <div class="event-body">
            <div class="event-name">中国氢能联盟理事会会议(受邀出席)</div>
            <div class="event-name-en">CHA Council Meeting (By Invitation Only)</div>
            <div class="event-location">
              <img :src="dwIcon" alt="" class="loc-icon" />
              <div class="loc-text">
                <div>国家会议中心 二期2层222、224</div>
                <div class="loc-en">Room 222、224, Level 2, China National Convention Center (Phase II)</div>
              </div>
            </div>
          </div>
        </div>
        <div class="event-card">
          <div class="event-header">
            <div class="time">10:00-12:30</div>
            <div class="event-tag">· 开幕式 <span>Opening Ceremony</span></div>
          </div>
          <div class="event-body">
            <div class="event-name">CIHC2026国际氢能大会暨“十五五”氢能产业发展论坛</div>
            <div class="event-name-en">CIHC 2026 & the “15th Five-Year Plan” Hydrogen Development Forum</div>
            <div class="event-location">
              <img :src="dwIcon" alt="" class="loc-icon" />
              <div class="loc-text">
                <div>国家会议中心 二期2层223</div>
                <div class="loc-en">Room 223, Level 2, China National Convention Center (Phase II)</div>
              </div>
            </div>
          </div>
        </div>
        <div class="event-card">
          <div class="event-header">
            <div class="time">14:00-17:00</div>
            <div class="event-tag">· 专题会议1 <span>Thematic Session I</span></div>
          </div>
          <div class="event-body">
            <div class="event-name">绿氢交易国际合作论坛</div>
            <div class="event-name-en">International Green Hydrogen Trading & Cooperation Forum</div>
            <div class="event-location">
              <img :src="dwIcon" alt="" class="loc-icon" />
              <div class="loc-text">
                <div>国家会议中心 二期2层223</div>
                <div class="loc-en">Room 223, Level 2, China National Convention Center (Phase II)</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 2026年3月26日 -->
    <div class="day-section">
      <div class="date-header">
        <div class="date-cn">2026年3月26日</div>
        <div class="date-en">March 26, 2026</div>
      </div>
      <div class="timeline">
        <div class="event-card">
          <div class="event-header">
            <div class="time">09:30-17:00</div>
            <div class="event-tag">· 专题会议2 <span>Thematic Session II</span></div>
          </div>
          <div class="event-body">
            <div class="event-name">氢能产融创新合作论坛</div>
            <div class="event-name-en">Hydrogen Industry-Finance Innovation & Cooperation Forum</div>
            <div class="event-location">
              <img :src="dwIcon" alt="" class="loc-icon" />
              <div class="loc-text">
                <div>国家会议中心 一期1层氢创未来厅</div>
                <div class="loc-en">Hydrogen Innovation Hall, Level 1, China National Convention Center (Phase I)</div>
              </div>
            </div>
          </div>
        </div>
        <div class="event-card">
          <div class="event-header">
            <div class="time">09:30-12:00</div>
            <div class="event-tag">· 边会 <span>Side Event</span></div>
          </div>
          <div class="event-body">
            <div class="event-name">绿氢耦合化工创新论坛</div>
            <div class="event-name-en">Green Hydrogen-Chemical Industry Integration Innovation Forum</div>
            <div class="event-location">
              <img :src="dwIcon" alt="" class="loc-icon" />
              <div class="loc-text">
                <div>国家会议中心 二期2层212</div>
                <div class="loc-en">Room 212, Level 2, China National Convention Center (Phase II)</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 返回按钮 -->
    <div class="back-btn-wrap">
      <van-button type="primary" round @click="close" class="back-btn">关 闭<br />
                  <span class="btn-en">CLose</span></van-button>
    </div>
  </div>
    </van-popup>

    <!-- 场地查询弹层 -->
    <van-popup v-model:show="showPlacePopup" position="bottom" :style="{ height: '90%' }" round>
      <div class="place-popup">
        <h1 class="popup-title">场地查询</h1>
        <van-field
          v-model="placeResult"
          is-link
          readonly
          name="picker"
          label="日期选择"
          placeholder="请选择"
          @click="showPlaceDatePicker = true"
        />
        <van-popup v-model:show="showPlaceDatePicker" destroy-on-close position="bottom">
          <van-picker
            :columns="placeDateColumns"
            :model-value="placeDatePickerValue"
            @confirm="onPlaceDateConfirm"
            @cancel="showPlaceDatePicker = false"
          />
        </van-popup>
        <div class="place-img">
          <img :src="placeDemo" @click="previewPlaceImg" />
        </div>
        <div class="preview-img-mask" v-if="showPlacePreview" @click="showPlacePreview = false">
          <div>
            <img :src="placePreImg" alt="" />
          </div>
        </div>
        <div class="popup-btn-wrap">
          <van-button :color="mainColor" plain type="primary" @click="showPlacePopup = false">关闭</van-button>
          <van-button :color="mainColor" type="primary">一键官网</van-button>
        </div>
      </div>
    </van-popup>
  </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import cropper from '@/components/cropper.vue'
import quetions from './components/questions-common.vue'
import chooseMeet from './components/chooseMeet.vue'
import {
  validatorName,
  validatorComName,
  validatorGender,
  validatorRank,
  validateDept,
  validatorMobile,
  validatorEmail,
  validatorAddress,
  validatorUrl,
  validatorFax,
  validateZipCode
} from '@/utils/validators.js'
import { regCId, regIDNumber } from '@/utils/regs.js'
import api from '@/api'
import { formConfig, quesConfig } from '@/utils/form.js'
import { formConfigC, quesConfigC } from '@/utils/cForm.js'
import wx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'
import placeDemo from '@/assets/demo.png'
import dwIcon from '@/assets/dwicon.png'

const store = useStore()
const token = computed(() => store.state.token)
const ExhCode = computed(() => store.state.ExhCode)
const loginForm = computed(() => store.state.loginForm)
const isPC = computed(() => store.state.isPC)
const mainColor = computed(() => store.state.mainColor)
const openid = computed(() => store.state.openid)
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const isSelectingSuggestion = ref(false)

const tabac = ref(sessionStorage.getItem('tabac'))
const formMg = ref({
  Name: '',
  ComName: '',
  Gender: '', // n
  Rank: '',
  Dept: '', // n
  Mobile: loginForm.value.mobile || '',
  Country: tabac.value === 'gat' ? '' : '中国',
  Province: '',
  City: '',
  Email: loginForm.value.Email || '',
  Address: '',
  WebUrl: '', // n
  Fax: '', // n
  Tel: '',
  IDCardNo: '',
  Trade: '', // n
  ZipCode: '', // n
  Remark: '', // n
  photo: '',
  IDCardType: '',
  OpenID: '',
  AliID: '',
  QueAndAnswers: ''
})

const companySuggestions = ref([]) // 用于存储接口返回的建议内容
const suggestionListRef = ref(null) // 建议列表容器引用
const companyInputTimer = ref(null)
watch (() => formMg.value.ComName, // 修正属性名
  (newVal) => {
    if (isSelectingSuggestion.value) {
      isSelectingSuggestion.value = false // 重置标志位
      return
    }
    // 注意：您需要定义 onCompanyInput 函数
    onCompanyInput(newVal)
  },
  { immediate: false }
)
// 日程查看弹层
const showSchedulePopup = ref(false)
const schedulePopupRef = ref(null)
const onScheduleOpened = () => {
  nextTick(() => {
    setTimeout(() => {
      const el = schedulePopupRef.value?.$el
      if (el) el.scrollTop = 0
      const page = document.querySelector('.schedule-page')
      if (page) page.scrollTop = 0
    }, 50)
  })
}
// 返回上一页函数
const goBack = () => {
  history.back(-1) // 或者使用 router.back()
}
const close = () => {
  showSchedulePopup.value = false // 或者使用 router.back()
}
const onCompanyInput = () => {
  const value = formMg.value.ComName
  // 清除之前的定时器
  if (companyInputTimer.value) {
    clearTimeout(companyInputTimer.value)
  }

  // 设置新的定时器，实现防抖
  companyInputTimer.value = setTimeout(() => {
    // console.log("132",value);
    if (value && value.length >= 4) { // 当输入至少2个字符时才调用接口
    // console.log(value.length);
      fetchCompanySuggestion(value)
    } else {
      companySuggestions.value = [] // 输入字符过少时清空建议
    }
  }, 500) // 500ms防抖延迟
}
// 调用接口获取单位名称相关建议
const fetchCompanySuggestion = (companyName) => {
  //  console.log('companyName111:', companyName);
  // 这里替换为你的实际API调用
  // 示例：
  // companySuggestions.value = ['杭州奥极科技有限公司','广州市奥极艺国际进出口有限公司','深圳市奥极健康有限公司','北京奥极科技有限公司','上海奥极科技服务有限公司'];
  // return;
  api.getCompanySuggestion({ ExhCode: ExhCode.value, companyname: companyName }).then(res => {
    if (res.code === 200 && res.data) {
      companySuggestions.value = [...res.data.checkResult, '手动填写']
        console.log('companySuggestions1:', companySuggestions.value.length)
    } else {
      companySuggestions.value = []
        console.log('companySuggestions2:', companySuggestions.value.length)
    }
  }).catch(() => {
    companySuggestions.value = []
  })

  console.log('companySuggestions3:', companySuggestions.value.length)
  // 模拟接口调用（请替换为实际接口）
  // this.companySuggestions = ['杭州奥极科技有限公司','广州市奥极艺国际进出口有限公司','深圳市奥极健康有限公司','北京奥极科技有限公司','上海奥极科技服务有限公司'];
}
const selectSuggestion = (suggestion) => {
  isSelectingSuggestion.value = true
  if (suggestion !== '手动填写') {
    formMg.value.ComName = suggestion
  }
  companySuggestions.value = [] // 选择后清空建议列表
}

const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}
const isClickCh = ref(false)
const isWeX = computed(() => store.state.isWeX)
const router = useRouter()
const route = useRoute()



// 场地查询弹层
const showPlacePopup = ref(false)
const placeResult = ref('')
const placeDatePickerValue = ref([])
const showPlaceDatePicker = ref(false)
const placeDateColumns = [
  { text: '2025-12-29', value: '2025-12-29' },
  { text: '2025-12-30', value: '2025-12-30' },
  { text: '2025-12-31', value: '2025-12-31' }
]
const onPlaceDateConfirm = ({ selectedValues, selectedOptions }) => {
  placeResult.value = selectedOptions[0]?.text
  placeDatePickerValue.value = selectedValues
  showPlaceDatePicker.value = false
}
// 场地图片预览
const placePreImg = ref('')
const showPlacePreview = ref(false)
const previewPlaceImg = () => {
  showPlacePreview.value = true
  placePreImg.value = placeDemo
}
const actid = route.query.id
/** 协助注册与双通注册一致，另外显示手机号，另外提交需要添加邀请参数 */
// 协助注册参数
const pageType = ref(route.query.type)
// 双通或单人注册
const regType = ref(route.query.regType)
// 问卷配置
const useQues = ref([])
if (regType.value === 'hz') {
  useQues.value = quesConfigC
} else {
  useQues.value = quesConfig
}
onMounted(() => {
  getForm()
  if (actid) {
    getMeetDetail()
  }
  if (isWeX.value) {
    wx.getWXSign()
  }
  // 添加全局点击事件监听，点击外部关闭建议列表
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  // 移除全局点击事件监听
  document.removeEventListener('click', handleClickOutside)
})

// 点击外部关闭建议列表
const handleClickOutside = (event) => {
  const suggestionEl = document.querySelector('.suggestion-list')
  if (suggestionEl && !suggestionEl.contains(event.target)) {
    companySuggestions.value = []
  }
}

// 校验省份
const validatorProvince = (val, { required }) => {
  if (required) {
    if (formMg.value.Country === '中国') {
      if (val) {
        return true
      }
      console.log('shengsheng')
      return false
    }
    return true
  }
  return true
}
// 校验城市
const validatorCity = (val, { required }) => {
  if (required) {
    if (formMg.value.Country === '中国') {
      if (val) {
        return true
      }
      return false
    }
    return true
  }
  return true
}
// 校验证件号
const validatorIDCardNo = (val, { required }) => {
  if (required) {
    if (val) {
      // if (
      //   formMg.value.IDCardType &&
      //   formMg.value.IDCardType === '中国大陆居民身份证'
      // ) {
      //   return regCId(val)
      // } else if (
      //   !formMg.value.IDCardType &&
      //   formMg.value.Country &&
      //   formMg.value.Country === '中国'
      // ) {
      //   return regCId(val)
      // } else if (
      //   formMg.value.IDCardType === '' &&
      //   formMg.value.Country === ''
      // ) {
      //   return regCId(val)
      // } else {
      return regIDNumber.test(val)
      // }
    }
    return false
  } else {
    if (val) {
      if (
        formMg.value.IDCardType === '中国大陆居民身份证' ||
        formMg.value.Country === '中国' ||
        (formMg.value.IDCardType === '' && formMg.value.Country === '')
      ) {
        return regCId(val)
      } else {
        return regIDNumber.test(val)
      }
    }
  }
  return true
}
const rulesAll = ref({})
const rulesModel = {
  Name: [
    {
      required: false,
      validator: validatorName,
      message: '请输入正确的',
      emessage: 'please enter the correct'
    }
  ],
  ComName: [
    {
      required: false,
      validator: validatorComName,
      message: '请输入正确的',
      emessage: 'please enter the correct'
    }
  ],
  ComEName: [
    { required: false, message: '请输入', emessage: 'please enter the correct' }
  ],
  Gender: [
    {
      required: false,
      validator: validatorGender,
      message: '请选择',
      emessage: 'please select'
    }
  ],
  Rank: [
    {
      required: false,
      validator: validatorRank,
      message: '请输入正确的',
      emessage: 'please enter the correct'
    }
  ],
  Dept: [
    {
      required: false,
      validator: validateDept,
      message: '请输入',
      emessage: 'please enter the correct'
    }
  ],
  Mobile: [
    {
      required: false,
      validator: validatorMobile,
      message: '请输入正确的',
      emessage: 'please enter the correct'
    }
  ],
  Country: [
    { required: false, message: '请选择', emessage: 'please enter the correct' }
  ],
  Province: [
    {
      required: false,
      validator: validatorProvince,
      message: '请选择',
      emessage: 'please select'
    }
  ],
  City: [
    {
      required: false,
      validator: validatorCity,
      message: '请选择',
      emessage: 'please select'
    }
  ],
  Email: [
    {
      required: false,
      validator: validatorEmail,
      message: '请输入正确的',
      emessage: 'please enter the correct'
    }
  ],
  Address: [
    {
      required: false,
      validator: validatorAddress,
      message: '请输入正确的',
      emessage: 'please enter the correct'
    }
  ],
  WebUrl: [
    {
      required: false,
      validator: validatorUrl,
      message: '请输入正确的',
      emessage: 'please enter the correct'
    }
  ],
  Fax: [
    {
      required: false,
      validator: validatorFax,
      message: '请输入正确的',
      emessage: 'please enter the correct'
    }
  ],
  Tel: [
    {
      required: false,
      validator: validatorFax,
      message: '请输入正确的',
      emessage: 'please enter the correct'
    }
  ],
  IDCardNo: [
    {
      required: false,
      validator: validatorIDCardNo,
      message: '请输入正确的',
      emessage: 'please enter the correct'
    }
  ],
  Trade: [{ required: false, message: '请选择' }],
  ZipCode: [
    {
      required: false,
      validator: validateZipCode,
      message: '请输入正确的',
      emessage: 'please enter the correct'
    }
  ],
  Remark: [
    { required: false, message: '请输入', emessage: 'please enter the correct' }
  ],
  photo: [{ required: true, message: '请上传' }],
  IDCardType: [
    { required: true, message: '请选择', emessage: 'please enter the correct' }
  ],
  ExtField1: [
    { required: true, message: '请选择', emessage: 'please enter the correct' }
  ],
  ExtField2: [
    { required: true, message: '请输入', emessage: 'please enter the correct' }
  ]
}
// 解析选项
const dealOp = (str) => {
  if (str) {
    return str.split(';').map((item) => {
      return { text: item, value: item }
    })
  } else {
    return []
  }
}
// 行业选项
const tradeOptions = ref([])
const ExtField1Ops = ref([])
// 获取信息配置
const formItems = ref([])
const getForm = async () => {
  let formObj = formConfig
  if (regType.value === 'hz') {
    // 合作报名
    formObj = formConfigC
  }
  formItems.value = formObj
    .filter((item) => {
      if (pageType.value === 'help' || regType.value === 'hz') {
        // 协助注册 显示手机 手机号输入
        if (pageType.value === 'help') {
          formMg.value.Mobile = ''
        }
        return item.IsShow
      } else {
        // 非协助注册 隐藏手机
        if (item.key !== 'Mobile') {
          return item.IsShow
        }
      }
    })
    .sort((a, b) => {
      return a.Sort - b.Sort
    })
  formItems.value.forEach((item) => {
    if (
      item.key === 'Gender' ||
      item.key === 'Country' ||
      item.key === 'Province' ||
      item.key === 'City' ||
      item.key === 'Trade' ||
      item.key === 'photo' ||
      item.key === 'IDCardType' ||
      item.key === 'ExtField1'
    ) {
      if (item.key === 'Country') {
        item.Name = tabac.value === 'gat' ? '地区' : item.Name
      }
      rulesModel[item.key][0].message =
        rulesModel[item.key][0].message +
        item.Name +
        '/' +
        rulesModel[item.key][0].emessage +
        ' ' +
        item.EName
      if (item.key === 'Trade') {
        tradeOptions.value = dealOp(item.Options)
      }
      if (item.key === 'ExtField1') {
        ExtField1Ops.value = dealOp(item.Options)
      }
    } else {
      rulesModel[item.key][0].message =
        rulesModel[item.key][0].message +
        item.Name +
        '/' +
        rulesModel[item.key][0].emessage +
        ' ' +
        item.EName
    }
    rulesModel[item.key][0].required = item.IsMust
    rulesAll.value[item.key] = rulesModel[item.key]
  })
}
// 关闭上传头像
const sendphoto = (data) => {
  formMg.value.photo = data
  Object.assign(formMg.value, { photo: data })
}
// 表单验证失败
const onFailed = (errorInfo) => {
  console.log('failed', errorInfo)
}
// 表单验证成功提交
const chooseQues = ref(null)
const onSubmit = async (values) => {
  const chooseRes = chooseQues.value.nextHandler()
  // 问卷验证没有通过不能提交
  if (!chooseRes) return
  // 根据 regType 设置 ExtField1 的值
  let extField1Value = ''
  if (regType.value === 'st') {
    extField1Value = '参会'
  } else if (regType.value === 'hz') {
    extField1Value = '合作'
  } else if (regType.value === 'gz') {
    extField1Value = '观展'
  } else {
    extField1Value = '参观' // 默认值
  }
  const subObj = {
    ...formMg.value,
    ExtField1: extField1Value
  }
  subObj.photoUrl = subObj.photo
  subObj.activityID = chooseMeetArr.value.map((item) => item.id).join(',')
  // console.log(subObj)
  // return
  // 是否有调查问卷
  // const hasQues = gconfig.value.IsHaveQuestion === 'True'
  const hasQues = false
  // 是否需要审核
  const param = {
    ...subObj,
    ExhCode: ExhCode.value,
    token: token.value,
    ifSubmit: !hasQues,
    OpenID: openid.value,
    AliID: '',
    source: sessionStorage.getItem('source') || '',
    invitesource: sessionStorage.getItem('invitesource') || '',
    invitesourceid: sessionStorage.getItem('invitesourceID') || '',
    lan: 'cn'
  }
  console.log(JSON.stringify(param), 'jdjdjjdjd')
  const res = await api.visitorSaveApi(param)
  if (res.code === 200) {
    if (hasQues) {
      router.push({ path: '/questions' })
      return
    }

    if (pageType.value && pageType.value === 'help') {
      // 协助他人注册跳转到当前人成功页 不保存vid
    } else {
      store.commit('setVisitorID', res.data.visitorID)
      sessionStorage.setItem('invitesource', '1')
      sessionStorage.setItem('invitesourceID', res.data.visitorID)
    }
    if (gconfig.value.SuccessPageVersion === 'V2') {
      router.push({ path: '/successV2' })
    } else {
      router.push({ path: '/success' })
    }
  }
}
// 行业下拉
const showTradePicker = ref(false)
const tradeConfirm = ({ selectedOptions }) => {
  formMg.value.Trade = selectedOptions[0].text
  showTradePicker.value = false
}

const hasChecked = ref([])
const showF1Picker = ref(false)
const showMeetList = () => {
  hasChecked.value = chooseMeetArr.value.map((item) => item.id)
  showF1Picker.value = true
}
// 邀请码
const chooseMeetArr = ref([])
// 确定会议选择 回显会议名称
const confirmChooseMeet = (chooseArr) => {
  // 会议选择提交
  chooseMeetArr.value = chooseArr
  // 表单文字显示
  formMg.value.ExtField1 = chooseMeetArr.value
    .map((item) => {
      return item.name
    })
    .join(';')
  showF1Picker.value = false
}

const f1Confirm = ({ selectedOptions }) => {
  formMg.value.ExtField1 = selectedOptions[0].text
  showF1Picker.value = false
}
// ExtField2 下拉
const showF2Picker = ref(false)
const f2Confirm = ({ selectedOptions }) => {
  formMg.value.ExtField2 = selectedOptions[0].text
  showF2Picker.value = false
}
// 国家下拉
const showPicker = ref(false)
const columns = ref([])
// columns.value = cpc.country1.map((item) => {
//   const tmpArr = item.split('_')
//   return { text: tmpArr[1], value: tmpArr[0] }
// })
const getCountry = () => {
  api.countryApi({}).then((res) => {
    columns.value = res.data.map((item) => {
      return { text: item.name, value: item.name }
    })
    if (tabac.value === 'gat') {
      columns.value = columns.value.splice(1, 3)
    }
  })
}
// getCountry()
const onConfirm = ({ selectedOptions }) => {
  formMg.value.Country = selectedOptions[0].text
  showPicker.value = false
  changeCountry()
}
// 国家变化
const changeCountry = () => {
  formMg.value.Province = ''
  formMg.value.City = ''
  columnsProvince.value = []
  columnsCity.value = []
  if (formMg.value.Country === '中国') {
    getProsH()
    // 修改省份/城市验证
    const pRule = rulesAll.value.Province
    const cRule = rulesAll.value.City
    const findPObj = formItems.value.find((item) => item.key === 'Province')
    if (findPObj) {
      if (findPObj.IsMust) {
        // 如果必选
        pRule[0].required = true
      } else {
        pRule[0].required = false
      }
    }
    const findCObj = formItems.value.find((item) => item.key === 'City')
    if (findCObj) {
      if (findCObj.IsMust) {
        // 如果必选
        cRule[0].required = true
      } else {
        cRule[0].required = false
      }
    }
    Object.assign(rulesAll.value, { Province: pRule, City: cRule })
    // 修改省份/城市验证 end
  } else {
    // 修改省份/城市验证
    const pRule = rulesAll.value.Province
    const cRule = rulesAll.value.Province
    pRule[0].required = false
    cRule[0].required = false
    Object.assign(rulesAll.value, { Province: pRule, City: cRule })
    // 修改省份/城市验证 end
  }
  if (formMg.value.Country === '中国') {
    formMg.value.IDCardType = '中国大陆居民身份证'
  } else if (
    formMg.value.Country === '中国香港' ||
    formMg.value.Country === '中国澳门'
  ) {
    formMg.value.IDCardType = '港澳通行证'
  } else if (formMg.value.Country === '中国台湾') {
    formMg.value.IDCardType = '台胞证'
  } else {
    formMg.value.IDCardType = '护照'
  }
}
// 省份下拉
// 获取省份下拉选项
const columnsProvince = ref([])
const getProsH = () => {
  // columnsProvince.value = cpc.province.map((item) => {
  //   const tmpArr = item.split('_')
  //   return { text: tmpArr[2], value: tmpArr[1] }
  // })
  api.proApi({}).then((res) => {
    columnsProvince.value = res.data.map((item) => {
      return { text: item.name, value: item.name }
    })
  })
}
getProsH()
const showPickerPro = ref(false)
const onConfirmProvince = ({ selectedOptions }) => {
  formMg.value.Province = selectedOptions[0].text
  showPickerPro.value = false
  changeProvince()
}
// 省份变化
const changeProvince = () => {
  formMg.value.City = ''
  columnsCity.value = []
  getCity()
}
// 城市
// 城市下拉
const columnsCity = ref([])
const getCity = () => {
  columnsCity.value = []
  // cpc.city.map((item) => {
  //   const tmpArr = item.split('_')
  //   if (formMg.value.Province === tmpArr[1]) {
  //     columnsCity.value.push({ text: tmpArr[3], value: tmpArr[2] })
  //   }
  // })
  api.cityApi({ name: formMg.value.Province }).then((res) => {
    columnsCity.value = res.data.map((item) => {
      return { text: item.name, value: item.name }
    })
  })
}
const showShopPicker = ref(false)

const shopConfirm = ({ selectedOptions }) => {
  formMg.value.City = selectedOptions[0].text
  showShopPicker.value = false
}
// 身份证件类型
const IDTypes = ref([
  { text: '中国大陆居民身份证 / Resident Identity Card of the People\'s Republic of China', value: '中国大陆居民身份证' },
  { text: '港澳通行证 / Exit-Entry Permit for Travelling to and from Hong Kong and Macao', value: '港澳通行证' },
  { text: '台胞证 / Mainland travel permit for Taiwan residents', value: '台胞证' },
  { text: '护照 / Passport', value: '护照' }
])
// 移动端显示用（分行显示）
const IDTypesDisplay = computed(() => {
  return IDTypes.value.map(item => {
    const parts = item.text.split(' / ')
    return {
      text: parts[0] + '\n' + parts[1],
      value: item.value
    }
  })
})
const showIDTypePicker = ref(false)
const IDTypeConfirm = ({ selectedOptions }) => {
  formMg.value.IDCardType = selectedOptions[0].value
  showIDTypePicker.value = false
}
// 获取会议详情
const getMeetDetail = async () => {
  const res = await api.getActiviInfoApi({ token: token.value, ActID: actid })
  formMg.value = { ...res.data }
  formMg.value.Name = res.data.RecipientName
}
</script>
<style lang="less">
@import '../../assets/login.less';
.label-en {
  font-size: 3vw;
  color: #7a7979;
  margin-left: 1vw;
}
/* 合作联系人信息样式 */
.cooperation-contact {
  padding: 16px;
 // margin: 16px;
  .contact-title {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #0020e8;
    border-radius: 10px;
    padding: 2px 12px;
    margin-bottom: 18px;
    text-align: left;
  }
  .contact-name,
  .contact-phone,
  .contact-email {
    font-size: 16px;
    color: #646566;
    margin-bottom: 6px;
    line-height: 1.5;
    display: flex;
    align-items: center;
  }
  .contact-icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  .contact-phone {
    color: #1989fa;
  }
  .contact-email {
    color: #1989fa;
    word-break: break-all;
  }
}

/* 修改建议列表样式 */
.suggestion-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 999;
  //max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
 // margin-top: 5px;
}

.suggestion-item {
  padding: 8px 12px;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-bottom: 5px;
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }

  &:last-child {
    border-bottom: none;
  }
}

/* 为包含建议列表的字段容器添加相对定位 */
.van-cell-group .van-cell:last-child {
  position: relative;
}

.lcbox {
  border: 1px solid #ececec;
  box-sizing: border-box;
  width: 99vw;
  border-radius: 3px;
  margin: 10px auto 0;
}

.fakeSel {
  position: relative;
  .van-field__value {
    opacity: 0;
  }
  select {
    position: absolute;
    top: 50px;
    left: 16px;
    padding: 13px 0;
    width: 93%;
    border: 1px solid #666;
    border-radius: 6px;
    outline: none;
    background: transparent;
    font-weight: normal;
    color: #323233;
    option {
      color: #323233;
    }
  }
}

.msg-form-wrapper {
  padding-top: 20px;
  padding-bottom: 30px;
  .van-button {
    border-radius: 10px;
  }
}

.btn-group-wrap {
  margin: 16px;
  display: flex;
  justify-content: space-between;
  .van-button {
    height: 50px;
    line-height: 1.4;
    border-radius: 10px;
  }
  .submit-btn {
    width: 100px;
  }
  .btn-en {
    font-size: 10px;
  }
}

.msg-divider {
  height: 1px;
  background-color: #7798f8;
  margin: 20px 16px;
}

.id-type-option {
  text-align: center;
  line-height: 1.4;
  .id-type-cn {
    font-size: 14px;
    color: #333;
  }
  .id-type-en {
    font-size: 11px;
    color: #666;
  }
}

/* 身份证件类型 picker 分行显示 */
.id-type-picker {
  .van-picker-column__item {
    white-space: pre-line !important;
    line-height: 1.4 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    height: 60px !important;
  }
}

.formDiv {
  padding: 0 4px 10px;
  width: 92%;
  margin: 0 auto;
  border-radius: 10px;
  position: relative;
  border: 1px solid #53a7fd;
  background-color: #fff;
}



// 头像
.photoForm {
  .van-field__value {
    text-align: center;
  }
  .van-field__body {
    display: inline-block;
    border: 0;
  }
}
.schedule-page {
  padding: 5vw 4vw;
  background-image: url('~@/assets/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-sizing: border-box;

  .page-title-cn {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 8px;
  }

  .page-title {
    text-align: center;
    font-size: 18px;
    font-weight: normal;
    color: #fff;
    margin-bottom: 5vw;
    letter-spacing: 2px;
  }

  .day-section {
    margin-bottom: 6vw;

    .date-header {
      margin-bottom: 4vw;
      text-align: left;
      .date-cn {
        font-size: 26px;
        font-weight: bold;
        color: #fff;
      }
      .date-en {
        font-size: 18px;
        color: #fff;
        margin-top: 4px;
      }
    }
  }

  .timeline {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .event-card {
    background: #fff;
    border-radius: 12px;
    border: 2px solid #5a9fff;
    overflow: hidden;

    .event-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 16px;
      background-color: #003df2;
      border-radius: 10px;
      margin-top: 10px;
      width: 90%;
      margin-left: auto;
      margin-right: auto;

      .time {
        font-size: 16px;
        color: #fff;
        font-weight: 600;
      }

      .event-tag {
        font-size: 13px;
        color: #fff;
        span {
          color: #fff;
          font-size: 12px;
        }
      }
    }

    .event-body {
      padding: 14px 16px;

      .event-name {
        font-size: 16px;
        color: #333;
        font-weight: 600;
        line-height: 1.5;
        text-align: left;
      }

      .event-name-en {
        font-size: 13px;
        color: #666;
        margin-top: 4px;
        text-align: left;
      }

      .event-location {
        display: flex;
        align-items: flex-start;
        margin-top: 12px;

        .loc-icon {
          width: 14px;
          height: 14px;
          margin-right: 6px;
          margin-top: 3px;
          flex-shrink: 0;
        }

        .loc-text {
          font-size: 13px;
          color: #666;
          text-align: left;
          .loc-en {
            font-size: 12px;
            color: #999;
            margin-top: 2px;
          }
        }
      }
    }
  }

  .back-btn-wrap {
    text-align: center;
    margin-top: 8vw;
    padding-bottom: 5vw;

    .van-button {
      width: 50vw;
    }

    .back-btn {
      background-color: #fff !important;
      color: #003df2 !important;
      border: 1px solid #003df2 !important;
      border-radius: 10px !important;
    }
  }
}

@media screen and (min-width: 768px) {
  .label-en {
    font-size: 12px !important;
    margin-left: 5px !important;
  }
  .fakeSel {
    select {
      top: 44px;
      left: 16px;
      width: calc(100% - 32px);
      padding: 10px 8px;
      border: 1px solid #2b84df;
      border-radius: 6px;
      font-size: 14px;
    }
  }

  .meet-wrap table td {
    padding: 10px;
  }
  .meet-wrap table td .meetItem {
    padding: 10px 0;
  }
  .meet-wrap {
    padding: 20px;
  }
  .meet-wrap .choose-meet-btn-wrap {
    padding-top: 20px;
  }
}

/* 日程查看弹层样式 */
.schedule-popup {
  padding: 5vw 4vw;
  background-color: #f5f7fa;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;

  .popup-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 4vw;
  }

  .day-section {
    margin-bottom: 5vw;

    .date-header {
      margin-bottom: 3vw;
      .date-badge {
        display: inline-block;
        background: linear-gradient(135deg, #1989fa, #47b3ff);
        color: #fff;
        padding: 6px 16px;
        border-radius: 16px;
        font-size: 14px;
        font-weight: bold;
        box-shadow: 0 2px 8px rgba(25, 137, 250, 0.3);
      }
    }
  }

  .timeline {
    position: relative;
    padding-left: 20px;

    &::before {
      content: '';
      position: absolute;
      left: 6px;
      top: 0;
      bottom: 0;
      width: 2px;
      background: linear-gradient(to bottom, #1989fa, #47b3ff);
    }

    .timeline-item {
      position: relative;
      padding-bottom: 16px;

      &:last-child {
        padding-bottom: 0;
      }

      .timeline-dot {
        position: absolute;
        left: -20px;
        top: 0;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #fff;
        border: 3px solid #1989fa;
        box-shadow: 0 2px 4px rgba(25, 137, 250, 0.3);
      }

      .timeline-content {
        .time {
          font-size: 13px;
          color: #1989fa;
          font-weight: 600;
          margin-bottom: 6px;
        }

        .event-card {
          background: #fff;
          border-radius: 8px;
          padding: 12px 14px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          border-left: 3px solid #1989fa;

          .event-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 8px;
            margin-bottom: 6px;
          }

          .event-name {
            flex: 1;
            font-size: 14px;
            color: #333;
            font-weight: 500;
            line-height: 1.5;
            text-align: left;
          }

          .van-tag {
            flex-shrink: 0;
            border-radius: 8px;
          }

          .event-location {
            font-size: 12px;
            color: #666;
            display: flex;
            align-items: center;
            &::before {
              content: '';
              display: inline-block;
              width: 12px;
              height: 12px;
              background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23999'%3E%3Cpath d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'/%3E%3C/svg%3E") no-repeat center;
              background-size: contain;
              margin-right: 4px;
            }
          }
        }
      }
    }
  }

  .popup-btn-wrap {
    text-align: center;
    margin-top: 5vw;
    padding-bottom: 3vw;

    .van-button {
      width: 40vw;
    }
  }
}

/* 场地查询弹层样式 */
.place-popup {
  padding: 5vw 4vw;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;

  .popup-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 4vw;
  }

  .place-img {
    padding: 3vw 0;
    img {
      width: 100%;
      border-radius: 8px;
    }
  }

  .popup-btn-wrap {
    text-align: center;
    margin-top: 4vw;
    display: flex;
    justify-content: center;
    gap: 4vw;

    .van-button {
      width: 28vw;
    }
  }
}

/* ========== PC端日程弹层独立样式 ========== */
@media screen and (min-width: 768px) {
  .van-popup--bottom.van-popup--round {
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }
  .schedule-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 12px 20px !important;
    box-sizing: border-box;
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    .page-title-cn {
      font-size: 28px;
      margin-bottom: 4px;
    }

    .page-title {
      font-size: 20px;
      margin-bottom: 16px;
    }

    .day-section {
      margin-bottom: 40px;

      .date-header {
        margin-bottom: 20px;
        .date-cn {
          font-size: 26px;
        }
        .date-en {
          font-size: 16px;
        }
      }
    }

    .event-card {
      .event-header {
        .time {
          font-size: 18px;
        }
      }

      .event-body {
        padding: 16px 20px;

        .event-name {
          font-size: 17px;
        }
      }
    }

    .back-btn-wrap {
      margin-top: 40px;
      padding-bottom: 20px;

      .van-button {
        width: 200px;
      }
    }
  }
}

.preview-img-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  img {
    width: 100%;
  }
}
</style>

<style lang="less">
/* 身份证件类型 picker 全局样式（popup 挂载在 body 上） */
.id-type-picker .van-picker-column__item {
  white-space: pre-line !important;
  line-height: 1.3 !important;
  height: 60px !important;
  padding: 5px 0 !important;
}
.id-type-picker .van-picker-column__item span,
.id-type-picker .van-picker-column__item--selected span {
  white-space: pre-line !important;
}
</style>
